module.exports = __webpack_public_path__ + "static/recordinglogo-ef7ab7121ce0577c3dcc2745157106bc.png";